import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type ReportFeedbackMutationVariables = Types.Exact<{
	input: Types.ReportFeedbackInput;
}>;

export type ReportFeedbackMutation = {
	__typename?: 'Mutation';
	reportFeedback: { __typename?: 'ReportFeedbackPayload'; isReported: boolean };
};

export const ReportFeedbackDocument = gql`
	mutation ReportFeedback($input: ReportFeedbackInput!) {
		reportFeedback(input: $input) {
			isReported
		}
	}
`;
